<div
  *ngIf="visible"
  class="modal-holder modal-outside-area"
  [ngClass]="{ centered: isSmall, scroll: scroll }"
  (click)="outsideClicked($event)"
>
  <div [@dialog] class="modal" *ngIf="visible" [ngClass]="{ small: isSmall }">
    <ng-content></ng-content>
  </div>
</div>
